import React from "react";

import { Button } from "~/components/button";

import { DashboardVariable } from "../../common/dashboard-spec";
import { DashboardVariablesBoundary } from "../../routes/dashboards/dashboard/variables-boundary";
import { CloseDrawerButton, DrawerTitle, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";
import { notification } from "../react/notification/Notification";

import { DrawerContent } from "./_drawer-content";
import type { DrawerState } from "./_drawer-state";
import { FORM_ID } from "./_form-id";

export interface DrawerProps {
	when: undefined | DrawerState;
}

export const Drawer: React.FC<DrawerProps> = ({ when }) => {
	return (
		<ExplorationDrawer
			footer={({ mode }) => <Footer isEditing={mode === "edit"} />}
			headerTitle={({ mode }) => (
				<DrawerTitle title={mode === "edit" ? "Edit Dashboard Variable" : "Add Dashboard Variable"} />
			)}
			id={when?.id}
			layout="full"
			when={when}
		>
			{({ mode, variables, timeRange, state, onSave }, close, preservedState) => (
				<DashboardVariablesBoundary timeRange={timeRange} variables={preservedState?.variables ?? variables}>
					<DrawerContent
						isEditing={mode === "edit"}
						onSave={(config) => {
							const output = DashboardVariable.of(config);
							if (output == null) {
								// should never happen but it is better to gracefully handle it
								notification.error({
									message: "Cannot save variable: invalid configuration",
								});
							} else {
								onSave(output);
								close();
							}
						}}
						state={preservedState?.state ?? state}
						timeRange={timeRange}
					/>
				</DashboardVariablesBoundary>
			)}
		</ExplorationDrawer>
	);
};

const Footer: React.FC<{
	isEditing: boolean;
}> = ({ isEditing }) => (
	<>
		<CloseDrawerButton />
		<Button className="uppercase" form={FORM_ID} type="submit" variant="primary">
			{isEditing ? "Update variable" : "Create variable"}
		</Button>
	</>
);
